import { Link } from "react-router-dom";
import { CheckCircle, Users, ArrowRight } from "@phosphor-icons/react";
import { PageHero, CTASection } from "../components/Sections";
import { Reveal } from "../components/Reveal";
import { CONSULENZE, IMAGES } from "../data/content";

export default function Consulenze() {
  return (
    <div data-testid="consulenze-page">
      <PageHero
        overline="Consulenze"
        title="Pacchetti di consulenza per far funzionare — e crescere — il tuo locale."
        subtitle="Ogni realtà ha esigenze diverse. Scegli il percorso più adatto: dall'intervento rapido all'affiancamento continuativo."
        image={IMAGES.shelves}
      />

      <section className="pb-24 sm:pb-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 space-y-6">
          {CONSULENZE.map((c, i) => (
            <Reveal key={c.slug} delay={i * 0.06}>
              <div data-testid={`consulenza-card-${c.slug}`} className="bg-[#111113] border border-white/5 rounded-sm p-8 lg:p-10 hover:border-[#D97736]/30 transition-all grid grid-cols-1 lg:grid-cols-12 gap-8">
                <div className="lg:col-span-7">
                  <div className="flex items-center gap-4">
                    <span className="font-display text-4xl font-bold text-[#D97736]/40">0{i + 1}</span>
                    <div>
                      <h2 className="font-display text-2xl sm:text-3xl font-semibold">{c.title}</h2>
                      <p className="text-[#D97736] text-sm mt-1">{c.tagline}</p>
                    </div>
                  </div>
                  <p className="mt-6 text-[#A1A1AA] leading-relaxed text-lg">{c.description}</p>
                  <div className="mt-6 flex items-start gap-3 bg-[#0b0b0d] border border-white/5 rounded-sm p-4">
                    <Users size={22} className="text-[#D97736] shrink-0 mt-0.5" />
                    <div>
                      <span className="text-xs uppercase tracking-wider text-[#D97736] font-semibold">A chi serve</span>
                      <p className="text-[#A1A1AA] text-sm mt-1">{c.forWho}</p>
                    </div>
                  </div>
                </div>
                <div className="lg:col-span-5 lg:border-l lg:border-white/5 lg:pl-8">
                  <span className="text-xs uppercase tracking-wider text-[#A1A1AA] font-semibold">Cosa include</span>
                  <ul className="mt-4 space-y-3">
                    {c.includes.map((inc) => (
                      <li key={inc} className="flex items-center gap-3 text-[#F8F8F8]">
                        <CheckCircle size={20} weight="fill" className="text-[#D97736] shrink-0" />
                        {inc}
                      </li>
                    ))}
                  </ul>
                  <Link to="/contatti" data-testid={`consulenza-cta-${c.slug}`} className="mt-8 inline-flex items-center gap-2 bg-[#D97736] text-white px-6 py-3 rounded-sm font-semibold hover:bg-[#B85B22] transition-all">
                    Richiedi info <ArrowRight size={18} />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTASection />
    </div>
  );
}
